export default __webpack_public_path__ + "static/media/screen_google_drive_01.7f6009c4.png";